import _get from 'lodash/get';
import * as Types from 'pages/Features/tabs/Profile/TimezoneAndWorkHours/typings';
import getWorkHoursByDayLookup from 'pages/Features/tabs/Profile/TimezoneAndWorkHours/helpers/getWorkHoursByDayLookup';
import DEFAULT_WORK_HOURS_BY_DAY from 'pages/Features/tabs/Profile/TimezoneAndWorkHours/constants';

function getDefaultTimezoneAndWorkHoursFormValue(
  clientSettings: any,
): Types.TimezoneAndWorkHoursFormState {
  const timezoneEnabled = _get(clientSettings, 'timezoneAndWorkHours.timezone.enabled', true);
  const hoursEnabled = _get(clientSettings, 'timezoneAndWorkHours.workHours.hoursEnabled', true);
  const locationEnabled = _get(
    clientSettings,
    'timezoneAndWorkHours.workHours.locationEnabled',
    true,
  );
  const workScheduleEnabled = timezoneEnabled && (hoursEnabled || locationEnabled);
  const defaultWorkHoursEnabled =
    workScheduleEnabled &&
    Boolean(_get(clientSettings, 'timezoneAndWorkHours.workHours.defaultWorkHours'));

  return {
    timezoneEnabled,
    workScheduleEnabled,
    hoursEnabled,
    locationEnabled,
    defaultWorkHoursEnabled,
    workHoursByDay: !!_get(clientSettings, 'timezoneAndWorkHours.workHours.defaultWorkHours')
      ? getWorkHoursByDayLookup(clientSettings.timezoneAndWorkHours.workHours.defaultWorkHours)
      : DEFAULT_WORK_HOURS_BY_DAY,
  };
}

export default getDefaultTimezoneAndWorkHoursFormValue;
